import { __exports as CODE128_AUTO } from "./index207.js";
import { __require as requireCODE128 } from "./index208.js";
import { __require as requireAuto } from "./index209.js";
var hasRequiredCODE128_AUTO;
function requireCODE128_AUTO() {
  if (hasRequiredCODE128_AUTO) return CODE128_AUTO;
  hasRequiredCODE128_AUTO = 1;
  Object.defineProperty(CODE128_AUTO, "__esModule", {
    value: true
  });
  var _CODE2 = requireCODE128();
  var _CODE3 = _interopRequireDefault(_CODE2);
  var _auto = requireAuto();
  var _auto2 = _interopRequireDefault(_auto);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var CODE128AUTO = (function(_CODE) {
    _inherits(CODE128AUTO2, _CODE);
    function CODE128AUTO2(data, options) {
      _classCallCheck(this, CODE128AUTO2);
      if (/^[\x00-\x7F\xC8-\xD3]+$/.test(data)) {
        var _this = _possibleConstructorReturn(this, (CODE128AUTO2.__proto__ || Object.getPrototypeOf(CODE128AUTO2)).call(this, (0, _auto2.default)(data), options));
      } else {
        var _this = _possibleConstructorReturn(this, (CODE128AUTO2.__proto__ || Object.getPrototypeOf(CODE128AUTO2)).call(this, data, options));
      }
      return _possibleConstructorReturn(_this);
    }
    return CODE128AUTO2;
  })(_CODE3.default);
  CODE128_AUTO.default = CODE128AUTO;
  return CODE128_AUTO;
}
export {
  requireCODE128_AUTO as __require
};
//# sourceMappingURL=index160.js.map
